export default __webpack_public_path__ + "static/media/mission.945c6186.png";